function findInNodes(nodes, categoryId) {
    let foundNode = null;

    for (let node of nodes) {
        if (node.id === categoryId) {
            foundNode = node;
            break;
        }

        if (node.child.length) {
            foundNode = findInNodes(node.child, categoryId);
        }

        if (foundNode) {
            break;
        }
    }

    return foundNode;
}

function getChildCategoryIds(category) {
    const childCategoryIds = [];

    category.child.forEach((childCategory) => {
        childCategoryIds.push(childCategory.id);

        childCategoryIds.push(...getChildCategoryIds(childCategory));
    });

    return childCategoryIds;
}

export default function useFiltersCategoriesRoot(categoriesTree, categoryIds) {
    const dontCheckCategoryIds = new Set();
    const categories = [];
    const filteredCategories = [];

    categoryIds.forEach((categoryId) => {
        const foundNode = findInNodes(categoriesTree, categoryId);
        if (foundNode) {
            categories.push(foundNode);
        }
    });

    categories.sort((a, b) => a.level - b.level);

    categories.forEach((category) => {
        if (!dontCheckCategoryIds.has(category.id)) {
            const childCategoryIds = getChildCategoryIds(category);
            childCategoryIds.forEach((childCategoryId) => dontCheckCategoryIds.add(childCategoryId));

            filteredCategories.push({
                ...category,
                childCategoryIds,
            });
        }
    });

    return filteredCategories;
}
